import { WidgetTypes } from '../Types/widgetTypes';



/**
 * Dashboard configuration for call analytics
 */
export const inboundCallsDashboard = {
    id: 'inbound-calls',
    name: 'Inbound Calls',
    description: 'Overview of inbound calls',
    widgets: [
        {
            id: 'widget-total-calls',
            type: WidgetTypes.METRIC,
            queryId: 'total-calls',
            title: 'Total Calls',
            titleKey: 'TOTAL_CALLS',
            icon: 'Phone',
            layout: {
                x: 0,
                y: 0,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'number',
                showTrend: true,
                trendFormat: 'percentage'
            }
        },
        {
            id: 'widget-answered-calls',
            type: WidgetTypes.METRIC,
            queryId: 'total-answered-calls',
            title: 'Answered Calls',
            titleKey: 'ANSWERED_CALLS',
            icon: 'CheckMark',
            layout: {
                x: 3,
                y: 0,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'number',
                showTrend: true,
                trendFormat: 'percentage'
            }
        },
        {
            id: 'widget-abandoned-calls',
            type: WidgetTypes.METRIC,
            queryId: 'total-abandoned-calls',
            title: 'Abandoned Calls',
            titleKey: 'ABANDONED_CALLS',
            icon: 'StatusErrorFull',
            layout: {
                x: 6,
                y: 0,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'number',
                showTrend: true,
                trendFormat: 'percentage'
            }
        },
        {
            id: 'widget-outbound-calls',
            type: WidgetTypes.METRIC,
            queryId: 'total-outbound-calls',
            title: 'Outbound Calls',
            titleKey: 'OUTBOUND_CALLS',
            icon: 'PhoneArrowOutbound',
            layout: {
                x: 6,
                y: 2,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'number',
                showTrend: true,
                trendFormat: 'percentage'
            }
        },
        {
            id: 'widget-transferred-calls',
            type: WidgetTypes.METRIC,
            queryId: 'total-transferred-calls',
            title: 'Transferred Calls',
            titleKey: 'TRANSFERRED_CALLS',
            icon: 'Switch',
            layout: {
                x: 9,
                y: 2,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'number',
                showTrend: true,
                trendFormat: 'percentage'
            }
        },
        {
            id: 'widget-thresholds-distribution',
            type: WidgetTypes.DONUT,
            queryId: 'response-time-distribution',
            title: 'Answer Time Thresholds',
            titleKey: 'ANSWER_TIME_THRESHOLDS',
            icon: 'PieChart',
            layout: {
                x: 4,
                y: 4,
                w: 4,
                h: 4,
                minW: 3,
                minH: 3
            },
            config: {
                nameKey: 'responseCategory',
                valueKey: 'callCount',
                categoryLabels: {
                    fast: 'Quick Answer',
                    standard: 'Standard Answer',
                    slow: 'Delayed Answer'
                },
                categoryColors: {
                    fast: '#00A4A6',
                    standard: '#1B3A6B',
                    slow: '#D13438'
                }
            }
        },
        {
            id: 'widget-average-wait-time',
            type: WidgetTypes.METRIC,
            queryId: 'average-wait-time',
            title: 'Average Wait Time',
            titleKey: 'AVERAGE_WAIT_TIME',
            icon: 'Clock',
            layout: {
                x: 9,
                y: 0,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'duration',
                showTrend: true,
                trendFormat: 'percentage',
                higherIsBetter: false
            }
        },
        {
            id: 'widget-average-ringing-time',
            type: WidgetTypes.METRIC,
            queryId: 'avg-ringing-time',
            title: 'Average Ringing Time',
            titleKey: 'AVG_RINGING_TIME',
            icon: 'Ringer',
            layout: {
                x: 9,
                y: 2,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'duration',
                showTrend: true,
                trendFormat: 'percentage',
                higherIsBetter: false
            }
        },
        {
            id: 'widget-avg-agents-per-call',
            type: WidgetTypes.METRIC,
            queryId: 'avg-agents-per-call',
            title: 'Avg Agents Alerted per Call',
            titleKey: 'AVG_AGENTS_PER_CALL',
            icon: 'People',
            layout: {
                x: 9,
                y: 4,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'number',
                decimals: 1,
                showTrend: true,
                trendFormat: 'percentage',
                higherIsBetter: false
            }
        },
        {
            id: 'widget-quick-drop-count',
            type: WidgetTypes.METRIC,
            queryId: 'quick-drop-count',
            title: 'Quick Drops',
            titleKey: 'QUICK_DROPS',
            icon: 'CallEnd',
            layout: {
                x: 9,
                y: 8,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'number',
                showTrend: true,
                trendFormat: 'percentage',
                higherIsBetter: false
            }
        },
        {
            id: 'widget-quick-drop-rate',
            type: WidgetTypes.METRIC,
            queryId: 'quick-drop-rate',
            title: 'Quick Drop Rate',
            titleKey: 'QUICK_DROP_RATE',
            icon: 'CallEnd',
            layout: {
                x: 9,
                y: 10,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'percentage',
                decimals: 1,
                showTrend: true,
                trendFormat: 'percentage',
                higherIsBetter: false
            }
        },
        {
            id: 'widget-overflow-rate',
            type: WidgetTypes.METRIC,
            queryId: 'overflow-rate',
            title: 'Queue Overflow Rate',
            titleKey: 'OVERFLOW_RATE',
            icon: 'Forward',
            layout: {
                x: 9,
                y: 6,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'percentage',
                decimals: 1,
                showTrend: true,
                trendFormat: 'percentage',
                higherIsBetter: false
            }
        },
        {
            id: 'widget-overflow-paths',
            type: WidgetTypes.BAR,
            queryId: 'overflow-paths',
            title: 'Top Queue Overflow Paths',
            titleKey: 'OVERFLOW_PATHS',
            icon: 'Route',
            layout: {
                x: 0,
                y: 36,
                w: 6,
                h: 5,
                minW: 4,
                minH: 4
            },
            config: {
                xAxisKey: 'path',
                yAxisKey: 'count',
                horizontal: true,
                showGrid: true,
                showLegend: false,
                valueFormat: 'number',
                tooltipSuffix: ' calls',
                alignTicksLeft: true
            }
        },
        {
            id: 'widget-overflow-matrix',
            type: WidgetTypes.TABLE,
            queryId: 'overflow-matrix',
            title: 'Queue Overflow Matrix',
            titleKey: 'OVERFLOW_MATRIX',
            icon: 'GridList',
            layout: {
                x: 6,
                y: 36,
                w: 6,
                h: 5,
                minW: 4,
                minH: 4
            },
            config: {}
        },
        {
            id: 'widget-service-level',
            type: WidgetTypes.METRIC,
            queryId: 'service-level',
            title: 'Service Level (SLA)',
            titleKey: 'SERVICE_LEVEL',
            icon: 'Trophy',
            layout: {
                x: 6,
                y: 1,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'percentage',
                showTrend: true,
                trendFormat: 'percentage',
                color: 'success'
            }
        },
        {
            id: 'widget-avg-inbound-call-duration',
            type: WidgetTypes.METRIC,
            queryId: 'average-inbound-call-duration',
            title: 'Avg Inbound Duration',
            titleKey: 'AVERAGE_INBOUND_CALL_DURATION',
            icon: 'PhoneArrowInbound',
            layout: {
                x: 0,
                y: 2,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'duration',
                showTrend: true,
                trendFormat: 'percentage',
                higherIsBetter: false
            }
        },
        {
            id: 'widget-avg-outbound-call-duration',
            type: WidgetTypes.METRIC,
            queryId: 'average-outbound-call-duration',
            title: 'Avg Outbound Duration',
            titleKey: 'AVERAGE_OUTBOUND_CALL_DURATION',
            icon: 'PhoneArrowOutbound',
            layout: {
                x: 3,
                y: 2,
                w: 3,
                h: 2,
                minW: 2,
                minH: 2
            },
            config: {
                format: 'duration',
                showTrend: true,
                trendFormat: 'percentage',
                higherIsBetter: false
            }
        },
        // ========================================
        // REPORT CONFIG WIDGETS (from Analytics Profile)
        // ========================================
        {
            id: 'widget-abandon-time',
            type: WidgetTypes.METRIC,
            queryId: 'max-abandon-time',
            title: 'Avg Abandon Time',
            titleKey: 'MAX_ABANDON_TIME',
            icon: 'Clock',
            layout: {
                x: 0,
                y: 6,
                w: 4,
                h: 2,
                minW: 3,
                minH: 2
            },
            config: {
                format: 'duration',
                showTrend: false,
                higherIsBetter: false,
                maxPath: 'abandonTime.maxAbandonTime',
                targetPath: 'abandonTime.targetAbandonTime'
            }
        },
        {
            id: 'widget-talking-time',
            type: WidgetTypes.METRIC,
            queryId: 'max-talking-time',
            title: 'Avg Talking Time',
            titleKey: 'MAX_TALKING_TIME',
            icon: 'Clock',
            layout: {
                x: 4,
                y: 6,
                w: 4,
                h: 2,
                minW: 3,
                minH: 2
            },
            config: {
                format: 'duration',
                showTrend: false,
                higherIsBetter: false,
                maxPath: 'talkingTime.maxTalkingTime',
                targetPath: 'talkingTime.targetTalkingTime'
            }
        },
        {
            id: 'widget-waiting-time',
            type: WidgetTypes.METRIC,
            queryId: 'max-waiting-time',
            title: 'Avg Waiting Time',
            titleKey: 'MAX_WAITING_TIME',
            icon: 'Clock',
            layout: {
                x: 8,
                y: 6,
                w: 4,
                h: 2,
                minW: 3,
                minH: 2
            },
            config: {
                format: 'duration',
                showTrend: false,
                higherIsBetter: false,
                maxPath: 'waitingTime.maxWaitingTime',
                targetPath: 'waitingTime.targetWaitingTime'
            }
        },
        {
            id: 'widget-call-volume-hourly',
            type: WidgetTypes.LINE,
            queryId: 'call-volume-by-hour',
            title: 'Hourly Call Volume',
            titleKey: 'HOURLY_CALL_VOLUME',
            icon: 'LineChart',
            layout: {
                x: 0,
                y: 4,
                w: 6,
                h: 4,
                minW: 4,
                minH: 3
            },
            config: {
                xAxisKey: 'hour',
                yAxisKey: 'callCount',
                showGrid: true,
                showLegend: true
            }
        },
        {
            id: 'widget-call-volume-daily',
            type: WidgetTypes.LINE,
            queryId: 'call-volume-by-day',
            title: 'Daily Call Volume',
            titleKey: 'DAILY_CALL_VOLUME',
            icon: 'LineChart',
            layout: {
                x: 6,
                y: 4,
                w: 6,
                h: 4,
                minW: 4,
                minH: 3
            },
            config: {
                xAxisKey: 'date',
                yAxisKey: 'callCount',
                showGrid: true,
                showLegend: true,
                xAxisFormatter: (value) => {
                    if (!value) return '';
                    const date = new Date(value);
                    const day = date.getDate();
                    const month = date.toLocaleDateString('en-US', { month: 'short' });
                    return `${month} ${day}`;
                }
            }
        },
        {
            id: 'widget-call-status-distribution',
            type: WidgetTypes.DONUT,
            queryId: 'call-status-distribution',
            title: 'Status Distribution',
            titleKey: 'CALL_STATUS_DISTRIBUTION',
            icon: 'PieDouble',
            layout: {
                x: 0,
                y: 8,
                w: 4,
                h: 4,
                minW: 3,
                minH: 3
            },
            config: {
                nameKey: 'status',
                valueKey: 'count',
                showLegend: true,
                showPercentage: true,
                // Default threshold for abandoned calls (in seconds)
                abandonedThreshold: 5  // > 5 sec in queue without agent = Abandoned
            }
        },
        {
            id: 'widget-calls-by-flow',
            type: WidgetTypes.DONUT,
            queryId: 'calls-by-flow',
            title: 'Calls by Flow',
            titleKey: 'CALLS_BY_FLOW',
            icon: 'Flow',
            layout: {
                x: 8,
                y: 8,
                w: 4,
                h: 4,
                minW: 3,
                minH: 3
            },
            config: {
                nameKey: 'flowName',
                valueKey: 'callCount',
                showLegend: true,
                showPercentage: true
            }
        },
        {
            id: 'widget-peak-hours',
            type: WidgetTypes.BAR,
            queryId: 'peak-hours-analysis',
            title: 'Peak Hours',
            titleKey: 'PEAK_HOURS',
            icon: 'BarChartVertical',
            layout: {
                x: 0,
                y: 12,
                w: 12,
                h: 5,
                minW: 6,
                minH: 4
            },
            config: {
                xAxisKey: 'hour',
                yAxisKey: 'averageWaitTime',
                secondaryYAxisKey: 'totalCalls',
                primaryYAxisName: 'AVG_WAIT_TIME',
                showGrid: true,
                showLegend: true,
                horizontal: false,
                xAxisFormatter: (value) => `${value}h`
            }
        },
        {
            id: 'widget-calls-per-agent',
            type: WidgetTypes.BAR,
            queryId: 'calls-per-agent',
            title: 'Calls per Agent',
            titleKey: 'CALLS_BY_AGENT',
            icon: 'People',
            layout: {
                x: 0,
                y: 17,
                w: 6,
                h: 5,
                minW: 4,
                minH: 4
            },
            config: {
                xAxisKey: 'agentName',
                yAxisKey: 'acceptedCalls',
                seriesKeys: ['acceptedCalls', 'ronaCalls'],
                seriesNames: ['ACCEPTED', 'RONA'],
                showGrid: true,
                showLegend: true,
                horizontal: false,
                stacked: false,
                valueFormat: 'number',
                tooltipSuffix: ' calls',
                alignTicksLeft: true
            }
        },
        {
            id: 'widget-avg-ringing-per-agent',
            type: WidgetTypes.BAR,
            queryId: 'calls-per-agent',
            title: 'Average Ringing Time by Agent',
            titleKey: 'AVG_RINGING_TIME_BY_AGENT',
            icon: 'Ringer',
            layout: {
                x: 0,
                y: 22,
                w: 6,
                h: 5,
                minW: 4,
                minH: 4
            },
            config: {
                xAxisKey: 'agentName',
                yAxisKey: 'avgRingingTime',
                showGrid: true,
                showLegend: false,
                horizontal: false,
                valueFormat: 'duration',
                alignTicksLeft: true
            }
        },
        {
            id: 'widget-calls-by-queue',
            type: WidgetTypes.DONUT,
            queryId: 'calls-by-queue',
            title: 'Calls by Queue',
            titleKey: 'CALLS_BY_QUEUE',
            icon: 'CallConnecting',
            layout: {
                x: 6,
                y: 17,
                w: 6,
                h: 5,
                minW: 4,
                minH: 4
            },
            config: {
                nameKey: 'queueName',
                valueKey: 'callCount',
                showLegend: true,
                showPercentage: true
            }
        },
        {
            id: 'widget-queue-kpi-summary',
            type: WidgetTypes.TABLE,
            queryId: 'queue-kpi-summary',
            title: 'Flow KPI Summary',
            titleKey: 'FLOW_KPI_SUMMARY',
            icon: 'Table',
            layout: {
                x: 0,
                y: 22,
                w: 12,
                h: 6,
                minW: 8,
                minH: 4
            },
            config: {
                // Columns will be auto-generated: first column = KPI names, subsequent columns = flow names
            }
        },
        {
            id: 'widget-month-to-date-summary',
            type: WidgetTypes.TABLE,
            queryId: 'month-to-date-summary',
            title: 'Month-to-Date Summary',
            titleKey: 'MONTH_TO_DATE_SUMMARY',
            icon: 'Calendar',
            layout: {
                x: 0,
                y: 28,
                w: 12,
                h: 7,
                minW: 8,
                minH: 5
            },
            config: {
                // Columns will be auto-generated: first column = KPI names, subsequent columns = flow names
            }
        },
        {
            id: 'widget-calls-served-time-ranges',
            type: WidgetTypes.TABLE,
            queryId: 'calls-served-by-time-ranges',
            title: 'Call Served by Time Ranges',
            titleKey: 'CALLS_SERVED_TIME_RANGES',
            icon: 'TaskComplete',
            layout: {
                x: 0,
                y: 35,
                w: 12,
                h: 5,
                minW: 4,
                minH: 3
            },
            config: {
                // Columns will be auto-generated: first column = time ranges, subsequent columns = flow names
            }
        },
        {
            id: 'widget-calls-abandoned-time-ranges',
            type: WidgetTypes.TABLE,
            queryId: 'calls-abandoned-by-time-ranges',
            title: 'Abandoned Calls by Time Ranges',
            titleKey: 'CALLS_ABANDONED_TIME_RANGES',
            icon: 'Cancel',
            layout: {
                x: 0,
                y: 40,
                w: 12,
                h: 5,
                minW: 4,
                minH: 3
            },
            config: {
                // Columns will be auto-generated: first column = time ranges, subsequent columns = flow names
            }
        },
        {
            id: 'widget-daily-sla-stats',
            type: WidgetTypes.SLA_TABLE,
            queryId: 'daily-sla-stats',
            title: 'Daily SLA Statistics',
            titleKey: 'DAILY_SLA_STATS',
            icon: 'Table',
            layout: {
                x: 0,
                y: 45,
                w: 12,
                h: 7,
                minW: 8,
                minH: 5
            },
            config: {
                slaThreshold: 85,
                slaSeconds: 30
            }
        },
        {
            id: 'widget-sla-trend',
            type: WidgetTypes.LINE,
            queryId: 'sla-trend',
            title: 'SLA Trend',
            titleKey: 'SLA_TREND',
            icon: 'LineChart',
            layout: {
                x: 0,
                y: 59,
                w: 12,
                h: 5,
                minW: 6,
                minH: 4
            },
            config: {
                xAxisKey: 'date',
                yAxisKey: 'slaValue',
                yAxisDomain: [0, 100],
                yAxisFormatter: (v) => `${v}%`,
                tooltipFormatter: (value, name) => [`${value}%`, 'SLA'],
                xAxisFormatter: (value) => {
                    if (!value) return '';
                    const d = new Date(value);
                    if (isNaN(d.getTime())) return value;
                    const day = d.getDate();
                    const month = d.toLocaleDateString('en-US', { month: 'short' });
                    return `${month} ${day}`;
                },
                // SLA threshold (seconds) comes from the Analytics Profile
                slaSecondsPath: 'waitingTime.targetWaitingTime'
            }
        },
        {
            id: 'widget-daily-abandon-stats',
            type: WidgetTypes.ABANDON_TABLE,
            queryId: 'daily-abandon-stats',
            title: 'Daily Abandon Statistics',
            titleKey: 'DAILY_ABANDON_STATS',
            icon: 'Table',
            layout: {
                x: 0,
                y: 52,
                w: 12,
                h: 10,
                minW: 12,
                minH: 8
            },
            config: {
                abandonSlaThreshold: 5
            }
        }
    ],
    filters: [
        {
            id: 'startDate',
            type: 'date',
            label: 'Start Date',
            required: true,
            defaultValue: () => {
                const date = new Date();
                date.setDate(date.getDate() - 7);
                return date.toISOString();
            }
        },
        {
            id: 'endDate',
            type: 'date',
            label: 'End Date',
            required: true,
            defaultValue: () => new Date().toISOString()
        }
    ]
};

/**
 * Configuration du dashboard d'analytics pour les files d'attente
 */
export const queueAnalyticsDashboard = {
    id: 'queue-analytics',
    name: 'Analyse des Files',
    description: 'Performance des files d\'attente',
    widgets: [
        {
            id: 'widget-queue-performance',
            type: WidgetTypes.TABLE,
            queryId: 'queue-performance',
            title: 'Performance par File',
            description: 'Métriques détaillées par file d\'attente',
            icon: 'Table',
            layout: {
                x: 0,
                y: 0,
                w: 12,
                h: 6,
                minW: 8,
                minH: 4
            },
            config: {
                columns: [
                    { key: 'queueName', name: 'File d\'Attente', nameKey: 'QUEUE_NAME', width: '25%' },
                    { key: 'totalCalls', name: 'Total', nameKey: 'TOTAL', width: '15%' },
                    { key: 'answeredCalls', name: 'Répondus', nameKey: 'ANSWERED', width: '15%' },
                    { key: 'abandonedCalls', name: 'Abandonnés', nameKey: 'ABANDONED', width: '15%' },
                    { key: 'avgWaitTime', name: 'Attente Moy.', nameKey: 'AVG_WAIT_TIME', width: '15%' },
                    { key: 'answerRate', name: 'Taux Réponse', nameKey: 'ANSWER_RATE_SHORT', width: '15%' }
                ],
                sortable: true,
                filterable: true
            }
        }
    ],
    filters: [
        {
            id: 'startDate',
            type: 'date',
            label: 'Date de début',
            required: true,
            defaultValue: () => {
                const date = new Date();
                date.setDate(date.getDate() - 7);
                return date.toISOString();
            }
        },
        {
            id: 'endDate',
            type: 'date',
            label: 'Date de fin',
            required: true,
            defaultValue: () => new Date().toISOString()
        }
    ]
};

/**
 * Liste de tous les dashboards disponibles
 */
export const availableDashboards = [
    inboundCallsDashboard,
    queueAnalyticsDashboard
];

export default {
    inboundCallsDashboard,
    queueAnalyticsDashboard,
    availableDashboards
};
